import $ from 'jquery'

class BlockFooterMain extends window.HTMLDivElement {
  constructor () {
    super()
    this.$ = $(this)
    this.resolveElements()
  }

  resolveElements () {
  }

  connectedCallback () {
  }
}

window.customElements.define('flynt-block-footer-main', BlockFooterMain, {extends: 'div'})



// WEBPACK FOOTER //
// ./Components/BlockFooterMain/script.js